import React, { FormEvent, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, ListItem, ListItemIcon, ListItemText, TextField } from '@material-ui/core';
import { Lock, Visibility, VisibilityOff } from '@material-ui/icons';
import { toast } from 'react-toastify';
import { changePassword, getUser, handleAxiosError, logout } from '../../utils/functions';
import Swal from 'sweetalert2';
import { IUser } from '../SignIn/interfaces';

const ChangePassword = () => {
    const initialState = {
        actualPassword: "",
        newPassword: "",
        repeatPassword: ""
    }

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(initialState);
    const [show, setShow] = useState({
        showActualPassword: false,
        showNewPassword: false,
        showRepeatPassword: false
    });

    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);

    const save = async (e: FormEvent) => {
        e.preventDefault();
        if (formData.newPassword !== formData.repeatPassword) {
            toast.error('La nueva contraseña no coincide con la confirmacion');
            return;
        }

        const user: IUser = getUser();

        const body = {
            username: user.username,
            oldPassword: formData.actualPassword,
            newPassword: formData.newPassword
        }

        try {
            if (user.idUsuario){
                const res = await changePassword(user.idUsuario, body)
    
                if (res.status === 200) {
                    Swal.fire({
                        title: "Contraseña cambiada correctamente",
                        icon: "success",
                        text: "Su contraseña ha sido cambiada exitosamente. Por favor, inicie sesión nuevamente."
                    }).then(() => logout(true));
                    setFormData(initialState);
                } else {
                    toast.error('No se pudo actualizar la contraseña');
                }
            } else {
                console.log(user);
            }
        } catch (error) {
            await handleAxiosError(error);
        }
    }

    return (
        <>
            <ListItem button onClick={openDialog}>
                <ListItemIcon>
                    <Lock />
                </ListItemIcon>
                <ListItemText primary="Cambiar mi contraseña" />
            </ListItem>

            <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm">
                <DialogTitle>Cambiar mi contraseña</DialogTitle>
                <form onSubmit={save}>
                    <DialogContent>
                        <DialogContentText>
                            Cambie la contraseña de su cuenta ISSET llenando el formulario a continuación.
                        </DialogContentText>
                        <TextField
                            fullWidth
                            type={show.showActualPassword ? "text" : "password"}
                            margin="dense"
                            required
                            variant="outlined"
                            value={formData.actualPassword}
                            onChange={e => setFormData({ ...formData, actualPassword: e.target.value })}
                            label="Contraseña actual"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <IconButton onClick={() => setShow({ ...show, showActualPassword: !show.showActualPassword })}>
                                        {show.showActualPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }}
                        />
                        <TextField
                            fullWidth
                            type={show.showNewPassword ? "text" : "password"}
                            margin="dense"
                            required
                            variant="outlined"
                            value={formData.newPassword}
                            onChange={e => setFormData({ ...formData, newPassword: e.target.value })}
                            label="Nueva contraseña"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <IconButton onClick={() => setShow({ ...show, showNewPassword: !show.showNewPassword })}>
                                        {show.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }}
                        />
                        <TextField
                            fullWidth
                            type={show.showRepeatPassword ? "text" : "password"}
                            margin="dense"
                            required
                            variant="outlined"
                            value={formData.repeatPassword}
                            onChange={e => setFormData({ ...formData, repeatPassword: e.target.value })}
                            label="Confirmar contraseña"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <IconButton onClick={() => setShow({ ...show, showRepeatPassword: !show.showRepeatPassword })}>
                                        {show.showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancelar</Button>
                        <Button type="submit">Guardar</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
};

export default ChangePassword;